import { Component, OnInit, Input, Output, forwardRef, EventEmitter } from '@angular/core';
import { FormBuilder, UntypedFormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators, ReactiveFormsModule } from '@angular/forms';
import { FundSource } from 'src/app/model/fund-source';
import { NgClass, UpperCasePipe } from '@angular/common';


@Component({
    selector: 'app-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    providers: [
        {
            provide: NG_VALIDATORS, useExisting: TextInputComponent, multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextInputComponent),
            multi: true
        }
    ],
    imports: [ReactiveFormsModule, NgClass, UpperCasePipe]
})
export class TextInputComponent implements OnInit {
  @Input() controllerData;
  @Input() parent: UntypedFormGroup;
  @Input() pageName: string;
  @Input() controlName: string;
  @Input() sourceData: FundSource;
  @Input() toUpperCase = false;
  @Input() isNumeric = false;
  @Output() textChangeEventEmitter: EventEmitter<string> = new EventEmitter<string>();
  onTouched: () => void;
  onChange = (value: string) => { };
  public textValue: string;
  /**
   * This is a constructor
   */
  constructor() {
  }

  ngOnInit() {
   
    if(this.parent.get([this.controlName])){
      this.textValue = this.parent.get([this.controlName]).value;
    }
    else{
      this.textValue = "";
    }
  }
  writeValue(value: any): void {
    this.controllerData['value'] = value ? value : null;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  getId() {
    let newId: string;
    if (this.controllerData['controlName'] === 'productCode' && this.sourceData && this.sourceData['code'] === 'J') {
      newId = this.sourceData['sourceName'] + this.controllerData['controlName'] + this.controlName;
    } else {
      newId = this.controllerData['name'];
    }
    return newId;
  }

  inputTextChangeHandler(val) {
    if(this.sourceData && (this.sourceData['code'] == 'H' || this.sourceData['code'] == 'F' || this.sourceData['code'] == 'O')) {
      this.parent.value [0] =  val;
    } 
    this.textChangeEventEmitter.emit(val);
  }
  addhyphen(data, event) {
    const isNumber = event.charCode >= 48 && event.charCode <= 57;
    // Generic numeric-only restriction for specific controls
    if (['sortcode', 'accountNumber'].includes(this.controlName)) {
      if (!isNumber && event.charCode > 31) {
        event.preventDefault();
        return;
      }
    }
    // Sort code formatting logic only for sortcode
    if (this.controlName === 'sortcode') {
      this.handleSortCodeFormatting(data, event);
    }
  }

  handleSortCodeFormatting(data: string, event) {
    const inputLength = data.length + 1;
    // Ignore backspace
    if (event.keyCode === 8) return;
    // Insert hyphen after 2nd and 5th characters
    if (inputLength === 2 || inputLength === 5) {
      const updated = `${data}${event.key}-`;
      this.parent.get(this.controllerData.controlName).setValue(updated);
      event.preventDefault();
    }
  }   

  validate() {
    // tslint:disable-next-line : max-line-length
    // changed as part of the story RA-3961- Add input validation on bank account page Account Holder(s) field

    const nameValidation: RegExp = (this.controlName === "accountHolder") ? /^(?=.{1,50}$)[a-zA-Z]+(?:[- '][a-zA-Z]+)*$/ : /^[a-zA-Z0-9_\-\\/]{1,50}$/g ;
    const forbidden = nameValidation.test(this.parent.get(this.controlName).value);


    if (this.controlName === 'textplanNumber' && this.parent.get(this.controlName).value) {
      return forbidden ? null : { notValidPlanNumber: true };
      // tslint:disable-next-line:align
    } else {
      if (this.controlName === "accountHolder" && this.parent.get(this.controlName).value) {
        return forbidden ? null : { notValidname: true };
        // tslint:disable-next-line:align
      } return null;
}
    return null;
  }
}
